<script setup lang="ts">import { ref as _ref, computed as _computed } from 'vue';

import { Log } from "@/models/Log";
import { useLoggingStore } from "@/stores/logging-store";
import { useRouter } from "vue-router";
import { RsModal } from "@/components";

const $router = useRouter();
let logDetail = _ref<Log | null>(null);

const hasLogs = _computed(() => {
  return useLoggingStore().Logs.length > 0;
});

const logs = _computed(() => {
  return useLoggingStore().Logs;
});

function onLogClicked(index: number): void {
  logDetail.value = useLoggingStore().Logs[index];
}

function onDismissClicked(): void {
  logDetail.value = null;
}

function back(): void {
  $router.back();
}
</script>
<template>
  <div class="tw-relative">
    <nav class="tw-bg-gray-800 tw-px-3 tw-py-1 tw-text-white">
      <a class="tw-py-1 tw-text-base tw-font-bold" href="#" @click.prevent>
        <button type="button" class="tw-btn-md-white tw-b-r tw-mr-1 tw-text-black" title="Back" @click.prevent="back">
          <i class="fas fa-arrow-left"></i>
        </button>
        Logs
      </a>
    </nav>
    <div class="tw-bg-white" style="margin: 1rem 2rem; padding: 2rem">
      <table v-if="hasLogs" class="tw-w-full tw-bg-gray-800 tw-text-white">
        <thead>
          <tr class="tw-border">
            <th class="tw-p-1" style="width: 10%">Level</th>
            <th class="tw-p-1" style="width: 70%">Message</th>
            <th class="tw-p-1" style="width: 15%">Date and Time</th>
            <th class="tw-p-1" style="width: 5%">&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(log, index) in logs" :key="`log-${index}`">
            <tr :class="index % 2 ? 'tw-bg-gray-800' : 'tw-bg-gray-600'">
              <th class="tw-p-1">{{ log.severity }}</th>
              <td class="tw-p-1">
                {{ log.message }}
              </td>
              <td class="tw-p-1">
                {{ log.dateTime?.toLocaleString() }}
              </td>
              <td class="tw-p-1 tw-text-right">
                <button
                  v-if="log.data !== null"
                  class="tw-btn-sm-white tw-b-r"
                  @click.prevent.stop="onLogClicked(index)"
                >
                  View
                </button>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
      <h2 v-else>There are no logs</h2>
    </div>
    <RsModal :show="!!logDetail && !!logDetail.data" @close="onDismissClicked">
      <template #modal-title>
        <div>
          <h5>Log detail</h5>
        </div>
      </template>
      <template #default>
        <div>
          <pre class="code"
            >{{ logDetail && logDetail.data && JSON.stringify(logDetail.data, null, 2) }}
          </pre>
        </div>
      </template>
    </RsModal>
  </div>
</template>
<style scoped>
.code {
  white-space: pre;
}
</style>
